import {
    SET_LEAD_APPROVE,
    SET_LEAD_APPROVE_SUCCESS,
    SET_LEAD_APPROVE_FAILURE,
} from '../constants/set_lead_approve.constants';

export const setLeadApproveRequest = params => ({
    type: SET_LEAD_APPROVE,
    params,
});

export const setLeadApproveSuccess = payload => ({
    type: SET_LEAD_APPROVE_SUCCESS,
    payload,
});

export const setLeadApproveFailure = error => ({
    type: SET_LEAD_APPROVE_FAILURE,
    error,
});



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_approval/redux/actions/set_lead_approve.actions.js